import { createSlice } from "@reduxjs/toolkit";
import { bannerService } from "../../services/siteContentService";
import { createCustomAsyncThunk, defaultEntityAdapter } from "../utils";


export const getSiteBanners = createCustomAsyncThunk(
    "banner/get",
    async params => await bannerService.get(params)
)


const siteBannerSlice = createSlice({
    name: "siteBanner",
    initialState: defaultEntityAdapter.getInitialState({
        isLoading: true,
        error: null
    }),

    extraReducers: builder => {
        builder
            .addCase(getSiteBanners.pending, state => { state.isLoading = true })
            .addCase(getSiteBanners.fulfilled, (state, action) => {
                defaultEntityAdapter.setAll(state, action.payload)
                state.isLoading = false
            })
            .addCase(getSiteBanners.rejected, (state, action) => {
                state.error = action.error
                state.isLoading = false
            })
    }
})


export const siteBannerSelector = defaultEntityAdapter.getSelectors(x => x.site.siteBanner)

export default siteBannerSlice.reducer